"use strict";
/**
 * PSHE themes — curated enum. Covers statutory RSHE and the PSHE Association
 * programme of study. Split into `basics` (bundled with every school) and
 * `premium` (marketplace upsell, often requiring named safeguarding review
 * before listing).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAFEGUARDING_THEMES = exports.THEMES_BY_TIER = void 0;
exports.getThemeLabel = getThemeLabel;
exports.getThemeTier = getThemeTier;
exports.isSafeguardingTheme = isSafeguardingTheme;
exports.kitRequiresSafeguardingReview = kitRequiresSafeguardingReview;
exports.THEMES_BY_TIER = {
    basics: [
        'road_safety',
        'stranger_danger',
        'online_safety',
        'healthy_relationships',
        'mental_health',
        'anti_bullying',
        'fire_safety',
        'healthy_eating',
        'british_values',
    ],
    premium: [
        'protective_behaviours',
        'pants_rule',
        'rse',
        'first_aid',
        'financial_education',
        'drug_alcohol_awareness',
        'knife_crime_awareness',
        'transition_to_secondary',
        'careers_aspirations',
        'young_carers_support',
        'bereavement_loss',
    ],
};
const PSHE_THEME_LABELS = {
    road_safety: 'Road Safety',
    stranger_danger: 'Stranger Danger',
    online_safety: 'Online Safety',
    healthy_relationships: 'Healthy Relationships',
    mental_health: 'Mental Health & Wellbeing',
    anti_bullying: 'Anti-Bullying',
    fire_safety: 'Fire Safety',
    healthy_eating: 'Healthy Eating',
    british_values: 'British Values',
    protective_behaviours: 'Protective Behaviours',
    pants_rule: 'The PANTS Rule (NSPCC)',
    rse: 'Relationships & Sex Education',
    first_aid: 'First Aid',
    financial_education: 'Financial Education',
    drug_alcohol_awareness: 'Drug & Alcohol Awareness',
    knife_crime_awareness: 'Knife Crime Awareness',
    transition_to_secondary: 'Transition to Secondary',
    careers_aspirations: 'Careers & Aspirations',
    young_carers_support: 'Young Carers Support',
    bereavement_loss: 'Bereavement & Loss',
};
function getThemeLabel(theme) {
    return PSHE_THEME_LABELS[theme];
}
function getThemeTier(theme) {
    return exports.THEMES_BY_TIER.basics.includes(theme) ? 'basics' : 'premium';
}
/** Themes that touch safeguarding and therefore require a named reviewer
 * + review date before they can be listed in the marketplace. */
exports.SAFEGUARDING_THEMES = [
    'stranger_danger',
    'protective_behaviours',
    'pants_rule',
    'rse',
    'knife_crime_awareness',
    'drug_alcohol_awareness',
    'bereavement_loss',
    'young_carers_support',
];
function isSafeguardingTheme(theme) {
    return exports.SAFEGUARDING_THEMES.includes(theme);
}
/**
 * Determines whether a kit requires safeguarding review provenance
 * (reviewedBy + reviewedOn) before it can be saved or published.
 *
 * The gate is theme/content-driven, NOT subject-conditional:
 * any kit with a safeguarding-relevant theme at the premium tier
 * requires review, regardless of the subject dropdown value.
 *
 * This is the single source of truth for both client (KitBuilderModal)
 * and server (POST /api/kits, POST /api/kits/:id/publish) enforcement.
 *
 * @param kit - Pick of ILearningKit with only the fields needed for the check
 * @returns true if the kit requires safeguarding review provenance
 */
function kitRequiresSafeguardingReview(kit) {
    return kit.contentTier === 'premium'
        && !!kit.theme
        && isSafeguardingTheme(kit.theme);
}
